var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"g_id_onload","data-client_id":_vm.clientId,"data-callback":"handleCredentialResponse"}}),_c('div',{staticClass:"g_id_signin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }